import { getAcompanhamentos } from "@spark/services/acompanhamentos";
import { useLatestAsyncRequest } from '@spark/ui-components/hooks/useLatestAsyncRequest';
import { useState, useEffect, useCallback } from 'react';
export const useAcompanhamentosListagem = (cargaId = null, depotId = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  const [filters, setFilters] = useState({
    cargaId: cargaId || '',
    depotId: depotId || '',
    numeroContainer: ''
  });
  const { beginRequest, isCurrentRequest, isMounted } = useLatestAsyncRequest(); // Cleanup quando componente é desmontado
  const fetchAcompanhamentos = useCallback(async () => {
    if (!isMounted()) return;

    const requestId = beginRequest();
    try {
      setLoading(true);
      setError(null); // Preparar filtros para o serviço

      const serviceFilters = {
        pagina: pagination.pageIndex + 1,
        quantidadePorPagina: pagination.pageSize
      };
      if (filters.search) serviceFilters.search = filters.search;
      if (filters.numeroCarga) serviceFilters.numeroCarga = filters.numeroCarga;
      if (filters.numeroNota) serviceFilters.numeroNota = filters.numeroNota;
      if (filters.numeroContainer) serviceFilters.numeroContainer = filters.numeroContainer;
      if (filters.dataInicio) serviceFilters.dataInicio = filters.dataInicio;
      if (filters.dataFim) serviceFilters.dataFim = filters.dataFim;
      if (filters.cargaId) serviceFilters.cargaId = filters.cargaId;
      if (filters.depotId) serviceFilters.depotId = filters.depotId; // Buscar acompanhamentos com filtros usando o serviço

      const response = await getAcompanhamentos(serviceFilters);
      if (!isCurrentRequest(requestId)) return; // Nova resposta: { registros, totalRegistros, paginaAtual, quantidadePorPagina }

      const registros = response?.registros ?? response?.acompanhamentos ?? response;
      const lista = Array.isArray(registros)
        ? registros.map((item) => ({
            ...item,
            NumeroContainer: item.NumeroContainer ?? item.Depot?.NumeroContainer ?? '',
          }))
        : [];

      setData(lista);
      setTotalRegistros(response?.totalRegistros ?? lista.length ?? 0);
    } catch (err) {
      if (!isCurrentRequest(requestId)) return;
      console.error('Erro ao buscar acompanhamentos:', err);
      setError('Erro ao carregar acompanhamentos');
    } finally {
      if (isCurrentRequest(requestId)) {
        setLoading(false);
      }
    }
  }, [beginRequest, filters, isCurrentRequest, isMounted, pagination.pageIndex, pagination.pageSize]); // Função para aplicar filtros

  const handleFilterChange = useCallback(newFilters => {
    setFilters(prev => ({
      ...prev,
      ...newFilters
    }));
    setPagination(prev => ({
      pageIndex: 0,
      pageSize: prev.pageSize
    }));
  }, []); // Carregar dados na montagem do componente

  useEffect(() => {
    fetchAcompanhamentos();
  }, [fetchAcompanhamentos]);
  return {
    // Estado
    data,
    loading,
    error,
    filters,
    totalRegistros,
    pagination,
    // Ações
    handleFilterChange,
    fetchAcompanhamentos,
    setPagination
  };
};
